/*
 * Copyright (C) 2018 Bruno López Trigo
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import {
    TextField,
    FormControlLabel,
    Checkbox,
    Tooltip,
    Paper,
    Typography,
    Button,
    CircularProgress
} from "@material-ui/core";
import {
    uploadDataset,
    buildClassifier,
    buildTree,
    deleteDataset
} from "../global/API";
import CustomizedSnackbars from "../global/CustomizedSnackbars";
import { Redirect } from "react-router-dom";

const styles = theme => ({
    root: {
        color: "#4caf50",
        "&$checked": {
            color: "#4caf50"
        }
    },
    checked: {},
    container: {
        marginBottom:100,
        paddingTop: 100,
        paddingBottom: 20,
        paddingLeft: 20,
        paddingRight: 20,
        margin: "auto",
        width: "90%",
        textAlign: "center"
    },
    textField: {
        width: "100%"
    },
    textFieldName: {
        width: "100%",
        marginTop: 20
    },
    booleanBar: {
        display: "-webkit-flex",
        webkitFlexWrap: "wrap",
        flexWrap: "wrap",
        justifyContent: "space-around"
    },
    button: {
        width:"150px",
        marginTop: "30px",
        backgroundColor: "#4caf50",
        fontSize: "20px",
        color: "white",
        "&:hover": {
            backgroundColor: "#357a38"
        }
    },
    buttonCancel: {
        width:"150px",
        marginTop: "30px",
        backgroundColor: "#ff5f52",
        fontSize: "20px",
        color: "white",
        "&:hover": {
            backgroundColor: "#C62828"
        }
    },
    icon: {
        marginLeft: 10
    },
    file: {
        marginTop: 20
    },
    progress: {
        margin: "auto",
        marginTop: 80,
        marginBottom: 30
    },
    loader: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        justifyItems: "center"
    }
});

class FormConfigureRandom extends Component {
    constructor(props) {
        super(props);
        this.state = {
            algorithm: "RandomForest",
            RandomForestParams: {
                bagSizePercent: 100,
                batchSize: 100,
                breakTiesRandomly: false,
                calcOutOfBag: false,
                completeAttributeImportance: false,
                debug:false,
                doNotCheckCapabilities: false,
                maxDepth:0,
                numDecimalPlaces: 2,
                numExecutionSlots: 1,
                numFeatures: 0,
                numIterations:100,
                outputOutOfBagComplexityStatistics:false,
                printClassifiers:false,
                seed:1,
                storeOutOfBagPredictions:false,
            }
        };
        this.buildClassifier = this.buildClassifier.bind(this);
        this.changeFile = this.changeFile.bind(this);
        this.saveConfiguration = this.saveConfiguration.bind(this);
        this.cancelConfiguration = this.cancelConfiguration.bind(this);
    }

    async saveConfiguration() {
        this.props.saveConfigurationRandomForest(this.state.RandomForestParams);
    }
    async cancelConfiguration() {
        this.props.exitConfigurationRandomForest();
    }
    handleClose = (event, reason) => {
        this.setState({
            error: false
        });
    };

    handleChange = name => event => {
        var regex = /^[A-Za-z0-9]{4,20}$/;
        this.setState({
            nameError: event.target.value.match(regex) ? false : true,
            [name]: event.target.value
        });
    };

    handleChangeParam = name => event => {
        var regex = /^-?[0-9]+\.?[0-9]*$/;
        var params = this.state.Randomparams;
        params[name] = event.target.value;
        this.setState({
            Randomparams: params,
            [name]: event.target.value.match(regex) ? false : true
        });
    };

    handleChangeBoolean = name => event => {
        var params = this.state.Randomparams;
        params[name] = event.target.checked;
        this.setState({ Randomparams: params });
    };

    changeFile(event) {
        this.setState({
            file: event.target.files[0]
        });
    }

    async buildClassifier() {
        if (
            !this.state.nameError &&
            !this.state.valueK &&
            !this.state.minNumObj &&
            !this.state.minVarianceProp &&
            !this.state.seed &&
            !this.state.maxDepth &&
            !this.state.numFolds &&
            !this.state.numDecimalPlaces &&
            this.state.file
        ) {
            this.setState({
                loading: true
            });
            var response = await uploadDataset(
                this.state.name,
                this.state.file,
                this.props.token
            );
            if (response.error) {
                if (response.status === 401) {
                    this.props.handleGlobalMessage(
                        "error",
                        this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                    );
                    this.props.closeSession();
                    this.setState({
                        loading: false,
                        redirect: true
                    });
                } else {
                    this.setState({
                        loading: false,
                        error: true,
                        message: response.data
                    });
                }
            } else {
                this.setState(
                    {
                        dataset: response.data
                    },
                    async () => {
                        response = await buildClassifier(
                            this.state.name,
                            this.state.Randomparams,
                            this.state.algorithm,
                            this.props.token
                        );
                        if (response.error) {
                            if (response.status === 401) {
                                this.props.handleGlobalMessage(
                                    "error",
                                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                );
                                this.props.closeSession();
                                this.setState({
                                    loading: false,
                                    redirect: true
                                });
                            } else {
                                await deleteDataset(this.state.name, this.props.token);
                                this.setState({
                                    loading: false,
                                    error: true,
                                    message: response.data
                                });
                            }
                        } else {
                            this.setState(
                                {
                                    classifier: response.data
                                },
                                async () => {
                                    response = await buildTree(
                                        this.state.name,
                                        this.state.algorithm,
                                        this.props.token
                                    );
                                    if (response.error) {
                                        if (response.status === 401) {
                                            this.props.handleGlobalMessage(
                                                "error",
                                                this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                            );
                                            this.props.closeSession();
                                            this.setState({
                                                loading: false,
                                                redirect: true
                                            });
                                        } else {
                                            await deleteDataset(this.state.name, this.props.token);
                                            this.setState({
                                                loading: false,
                                                error: true,
                                                message: response.data
                                            });
                                        }
                                    } else {
                                        this.props.handleGlobalMessage(
                                            "success",
                                            "Dataset " + this.state.name + this.props.language.labels[this.props.language.id].succesfullyCreated
                                        );
                                        this.setState({
                                            loading: false,
                                            ready: true
                                        });
                                    }
                                }
                            );
                        }
                    }
                );
            }
        } else if (this.props.classifierExists &&
            !this.state.nameError &&
            !this.state.valueK &&
            !this.state.minNumObj &&
            !this.state.minVarianceProp &&
            !this.state.seed &&
            !this.state.maxDepth &&
            !this.state.numFolds &&
            !this.state.numDecimalPlaces
        ) {
            this.setState({
                loading: true
            });
            response = await buildClassifier(
                this.props.dataset,
                this.state.Randomparams,
                this.state.algorithm,
                this.props.token
            );
            if (response.error) {
                if (response.status === 401) {
                    this.props.handleGlobalMessage(
                        "error",
                        this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                    );
                    this.props.closeSession();
                    this.setState({
                        loading: false,
                        redirect: true
                    });
                } else {
                    this.setState({
                        loading: false,
                        error: true,
                        message: response.data
                    });
                }
            } else {
                this.setState(
                    {
                        classifier: response.data
                    },
                    async () => {
                        response = await buildTree(
                            this.props.dataset,
                            this.state.algorithm,
                            this.props.token
                        );
                        if (response.error) {
                            if (response.status === 401) {
                                this.props.handleGlobalMessage(
                                    "error",
                                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                );
                                this.props.closeSession();
                                this.setState({
                                    loading: false,
                                    redirect: true
                                });
                            } else {
                                this.setState({
                                    loading: false,
                                    error: true,
                                    message: response.data
                                });
                            }
                        } else {
                            this.props.handleGlobalMessage(
                                "success",
                                "Dataset " + this.state.name + this.props.language.labels[this.props.language.id].succesfullyCreated
                            );
                            this.setState({
                                loading: false,
                                ready: true
                            });
                        }
                    }
                );
            }
        } else if (!this.state.file) {
            this.setState({
                error: true,
                message: "Please upload the dataset file"
            });
        } else {
            this.setState({
                error: true,
                message: "Wrong params, please check fields"
            });
        }
    }

    async componentDidMount() {}

    render() {
        const { classes } = this.props;

        return this.state.loading ? (
            <div className={classes.loader}>
                <CircularProgress className={classes.progress} size={100} />
                <Typography variant="h3" align="center">
                    {this.props.language.labels[this.props.language.id].loading}
                </Typography>
            </div>
        ) : (
            <Fragment>
                <Paper className={classes.container}>
                    <Typography variant="h4">
                        {this.props.language.labels[this.props.language.id].build +
                        " " +
                        this.state.algorithm}
                    </Typography>
                    <form>
                        <Tooltip
                            title="Size of each bag, as a percentage of the training set size."
                            placement="top"
                        >
                            <TextField
                                id="bagSizePercent"
                                label="bagSizePercent"
                                className={classes.textField}
                                value={this.state.RandomForestParams.bagSizePercent}
                                onChange={this.handleChangeParam("bagSizePercent")}
                                margin="normal"
                                error={this.state.bagSizePercentError}
                            />
                        </Tooltip>
                        <Tooltip
                            title="The preferred number of instances to process if batch prediction is being performed. More or fewer instances may be provided, but this gives implementations a chance to specify a preferred batch size."
                            placement="top"
                        >
                            <TextField
                                id="batchSize"
                                label="batchSize"
                                className={classes.textField}
                                value={this.state.RandomForestParams.batchSize}
                                onChange={this.handleChangeParam("batchSize")}
                                margin="normal"
                                error={this.state.batchSizeError}
                            />
                        </Tooltip>
                        <Tooltip
                            title="Sets the number of randomly chosen attributes. If 0, int(log_2(#predictors) + 1) is used."
                            placement="top"
                        >
                            <TextField
                                id="numFeatures"
                                label="numFeatures"
                                className={classes.textField}
                                value={this.state.RandomForestParams.numFeatures}
                                onChange={this.handleChangeParam("numFeatures")}
                                margin="normal"
                                error={this.state.numFeaturesError}
                            />
                        </Tooltip>
                        <Tooltip
                            title="Whether the out-of-bag error is calculated."
                            placement="top"
                        >
                            <TextField
                                id="seed"
                                label="seed"
                                className={classes.textField}
                                value={this.state.RandomForestParams.seed}
                                onChange={this.handleChangeParam("seed")}
                                margin="normal"
                                error={this.state.seedError}
                            />
                        </Tooltip>
                        <Tooltip
                            title="The maximum depth of the tree, 0 for unlimited."
                            placement="top"
                        >
                            <TextField
                                id="maxDepth"
                                label="maxDepth"
                                className={classes.textField}
                                value={this.state.RandomForestParams.maxDepth}
                                onChange={this.handleChangeParam("maxDepth")}
                                margin="normal"
                                error={this.state.maxDepthError}
                            />
                        </Tooltip>
                        <Tooltip
                            title="The number of decimal places to be used for the output of numbers in the model."
                            placement="top"
                        >
                            <TextField
                                id="numDecimalPlaces"
                                label="numDecimalPlaces"
                                className={classes.textField}
                                value={this.state.RandomForestParams.numDecimalPlaces}
                                onChange={this.handleChangeParam("numDecimalPlaces")}
                                margin="normal"
                                error={this.state.numDecimalPlacesError}
                            />
                        </Tooltip>
                        <Tooltip
                            title="The number of execution slots (threads) to use for constructing the ensemble."
                            placement="top"
                        >
                            <TextField
                                id="numExecutionSlots"
                                label="numExecutionSlots"
                                className={classes.textField}
                                value={this.state.RandomForestParams.numExecutionSlots}
                                onChange={this.handleChangeParam("numExecutionSlots")}
                                margin="normal"
                                error={this.state.numExecutionSlotsError}
                            />
                        </Tooltip>
                        <Tooltip
                            title="The number of trees in the random forest."
                            placement="top"
                        >
                            <TextField
                                id="numIterations"
                                label="numIterations"
                                className={classes.textField}
                                value={this.state.RandomForestParams.numIterations}
                                onChange={this.handleChangeParam("numIterations")}
                                margin="normal"
                                error={this.state.numIterationsError}
                            />
                        </Tooltip>
                        <div className={classes.booleanBar}>
                            <Tooltip
                                title="Whether the out-of-bag error is calculated."
                                placement="top"
                            >
                                <FormControlLabel
                                    className={classes.boolean}
                                    control={
                                        <Checkbox
                                            classes={{
                                                root: classes.root,
                                                checked: classes.checked
                                            }}
                                            checked={this.state.RandomForestParams.calcOutOfBag}
                                            onChange={this.handleChangeBoolean("calcOutOfBag")}
                                            value="calcOutOfBag"
                                            color="primary"
                                        />
                                    }
                                    label="calcOutOfBag"
                                />
                            </Tooltip>

                            <Tooltip
                                title="Compute attribute importance via mean impurity decrease"
                                placement="top"
                            >
                                <FormControlLabel
                                    className={classes.boolean}
                                    control={
                                        <Checkbox
                                            classes={{
                                                root: classes.root,
                                                checked: classes.checked
                                            }}
                                            checked={this.state.RandomForestParams.completeAttributeImportance}
                                            onChange={this.handleChangeBoolean("completeAttributeImportance")}
                                            value="completeAttributeImportance"
                                            color="primary"
                                        />
                                    }
                                    label="completeAttributeImportance"
                                />
                            </Tooltip>
                            <Tooltip
                                title=" If set, classifier capabilities are not checked before classifier is built (Use with caution to reduce runtime)"
                                placement="top"
                            >
                                <FormControlLabel
                                    className={classes.boolean}
                                    control={
                                        <Checkbox
                                            classes={{
                                                root: classes.root,
                                                checked: classes.checked
                                            }}
                                            checked={this.state.RandomForestParams.doNotCheckCapabilities}
                                            onChange={this.handleChangeBoolean("doNotCheckCapabilities")}
                                            value="doNotCheckCapabilities"
                                            color="primary"
                                        />
                                    }
                                    label="doNotCheckCapabilities"
                                />
                            </Tooltip>
                            <Tooltip
                                title="Whether to output complexity-based statistics when out-of-bag evaluation is performed"
                                placement="top"
                            >
                                <FormControlLabel
                                    className={classes.boolean}
                                    control={
                                        <Checkbox
                                            classes={{
                                                root: classes.root,
                                                checked: classes.checked
                                            }}
                                            checked={this.state.RandomForestParams.outputOutOfBagComplexityStatistics}
                                            onChange={this.handleChangeBoolean("outputOutOfBagComplexityStatistics")}
                                            value="outputOutOfBagComplexityStatistics"
                                            color="primary"
                                        />
                                    }
                                    label="outputOutOfBagComplexityStatistics"
                                />
                            </Tooltip>
                            <Tooltip
                                title=" Print the individual classifiers in the output"
                                placement="top"
                            >
                                <FormControlLabel
                                    className={classes.boolean}
                                    control={
                                        <Checkbox
                                            classes={{
                                                root: classes.root,
                                                checked: classes.checked
                                            }}
                                            checked={this.state.RandomForestParams.printClassifiers}
                                            onChange={this.handleChangeBoolean("printClassifiers")}
                                            value="printClassifiers"
                                            color="primary"
                                        />
                                    }
                                    label="printClassifiers"
                                />
                            </Tooltip>
                            <Tooltip
                                title="Whether to store the out-of-bag predictions."
                                placement="top"
                            >
                                <FormControlLabel
                                    className={classes.boolean}
                                    control={
                                        <Checkbox
                                            classes={{
                                                root: classes.root,
                                                checked: classes.checked
                                            }}
                                            checked={this.state.RandomForestParams.storeOutOfBagPredictions}
                                            onChange={this.handleChangeBoolean("storeOutOfBagPredictions")}
                                            value="storeOutOfBagPredictions"
                                            color="primary"
                                        />
                                    }
                                    label="storeOutOfBagPredictions"
                                />
                            </Tooltip>
                            <Tooltip
                                title="If set to true, classifier may output additional info to the console."
                                placement="top"
                            >
                                <FormControlLabel
                                    className={classes.boolean}
                                    control={
                                        <Checkbox
                                            classes={{
                                                root: classes.root,
                                                checked: classes.checked
                                            }}
                                            checked={this.state.RandomForestParams.debug}
                                            onChange={this.handleChangeBoolean("debug")}
                                            value="debug"
                                            color="primary"
                                        />
                                    }
                                    label="debug"
                                />
                            </Tooltip>
                            <Tooltip
                                title="Break ties randomly when several attributes look equally good."
                                placement="top"
                            >
                                <FormControlLabel
                                    className={classes.boolean}
                                    control={
                                        <Checkbox
                                            classes={{
                                                root: classes.root,
                                                checked: classes.checked
                                            }}
                                            checked={this.state.RandomForestParams.breakTiesRandomly}
                                            onChange={this.handleChangeBoolean("breakTiesRandomly")}
                                            value="breakTiesRandomly"
                                            color="primary"
                                        />
                                    }
                                    label="breakTiesRandomly"
                                />
                            </Tooltip>
                        </div>
                        <Button
                            variant="contained"
                            className={classes.button}
                            onClick={this.saveConfiguration}
                        >
                            {this.props.language.labels[this.props.language.id].saveButton}
                        </Button>
                        &nbsp;
                        &nbsp;
                        &nbsp;
                        <Button
                            variant="contained"
                            className={classes.buttonCancel}
                            onClick={this.cancelConfiguration}
                        >
                            {this.props.language.labels[this.props.language.id].cancelButton}
                        </Button>

                    </form>
                </Paper>
                <CustomizedSnackbars
                    openFail={this.state.error}
                    handleClose={this.handleClose}
                    message={this.state.message}
                />
                {this.state.redirect && <Redirect to="/" />}
                {this.state.ready && <Redirect to="/datasets" />}
            </Fragment>
        );
    }
}

FormConfigureRandom.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(FormConfigureRandom);
